import BarDemo from '../components/BarDemo';
import LineDemo from '../components/LineDemo';
import TableDemo from '../components/TableDemo';
import { Container, Row, Col, Tabs, Tab } from 'react-bootstrap'
import '../styles/dashboard.css'

function Dashboard() {
    return (
        <div className="dashboard">
            <Container>
                <Row className="my-5">
                    <TableDemo></TableDemo>
                </Row>
                <Row className="my-5">
                    <Col>
                        <Tabs defaultActiveKey="bar">
                            <Tab eventKey="bar" title="Bar">
                                <BarDemo></BarDemo>
                            </Tab>
                            <Tab eventKey="line" title="Line">
                                <LineDemo></LineDemo>
                            </Tab>
                        </Tabs>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Dashboard;
